import { ComponentProps, forwardRef, useContext } from 'react'
import { styled } from '../../../config'
import { DropdownContext } from '../DropdownContext'
import { DropdownPrimitives } from './Dropdown'

const StyledContent = styled(DropdownPrimitives.Content, {
  // scrollbar
  '&::-webkit-scrollbar': {
    width: '4px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'none'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '8px',
    background: '$gray0600',
    transition: '150ms'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '$gray0500'
  }
})

type Props = ComponentProps<typeof DropdownPrimitives.Content>

export const Content = forwardRef<HTMLDivElement, Props>(({ children, ...rest }: Props, ref) => {
  const { isDarkMode } = useContext(DropdownContext)

  return (
    <StyledContent ref={ref} side="bottom" sideOffset={4} dark={isDarkMode} {...rest}>
      {children}
    </StyledContent>
  )
})
